import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export { isPowerOfTwo, isNatural } from './numeric';

// Utility: Check if a number is prime
export function isPrime(num: number): boolean {
  if (num < 2) return false;
  for (let i = 2; i <= Math.sqrt(num); i++) {
    if (num % i === 0) return false;
  }
  return true;
}

export function queryParams(params: Record<string, string>): string {
  const queryParamsObj = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      queryParamsObj.set(key, value as string);
    }
  });
  return queryParamsObj.toString();
}

// Utility: Get initials from a full name (max 2 chars)
export function getInitials(name: string): string {
  if (!name || typeof name !== 'string') return '??';
  return name
    .split(' ')
    .filter(Boolean)
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

// Utility: Strip HTML tags and preserve line breaks
export function stripHtmlTags(html: string): string {
  if (!html || typeof html !== 'string') return '';

  // Convert block elements to line breaks, then strip all HTML
  const withLineBreaks = html
    .replace(/<(br|p|div|h[1-6])\b[^>]*>/gi, '\n')
    .replace(/<\/(p|div|h[1-6])>/gi, '\n');

  const doc = new DOMParser().parseFromString(withLineBreaks, 'text/html');
  const text = doc.body.textContent || '';

  // Clean up extra whitespace and newlines
  return text
    .replace(/\n\s+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
